import { render, staticRenderFns } from "./SetUpChangePwd.vue?vue&type=template&id=5b48bc78&"
import script from "./SetUpChangePwd.vue?vue&type=script&lang=js&"
export * from "./SetUpChangePwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports